import DesignSystem from '@locaweb/design-system-vue'
import '@locaweb/design-system-vue/dist/locastyle.css'
import locales from '@/locales'
import routes from '@/router'
import IconsPlugin from '@locaweb/design-system-icons'
import { PiniaVuePlugin } from 'pinia'

export default {
  install (vue) {
    // Configuração do Plugin do Pinea
    vue.use(PiniaVuePlugin)
    // Configuração do Design System
    vue.use(DesignSystem, {
      locales, // configuração do locales que pode ser acessado em cada componente por $lc
      env: process.env.NODE_ENV, // env usada durante o run da aplicação
      sentry: {
        dsn: process.env.VUE_APP_SENTRY_DSN
      },
      router: { routes }, // Configuração das rotas
      http: { // Configuração de um cliente http para a baseURL definida e com interceptador para por o cookie informado na request, caso ele exista
        baseURL: process.env.VUE_APP_API_BASE_URL,
        AuthorizationCookieName: process.env.VUE_APP_COOKIE_NAME
      },
      ga: {
        config: {
          id: 'G-XH2VLF75JZ'
        }, // configuração do id do GA, podendo receber um array de Ids
        appName: 'task-tracker' // nome da aplicação pro GA
      },
      gtm: {
        id: process.env.VUE_APP_CONTAINER_ID_GTM // Configuração do id do Google Tag Manager
      }
    })
    vue.use(IconsPlugin) // Configuração do plugin de icone do ecossistema do DS
  }
}
